import { useEffect, useRef, useState } from "react";
import { Image, Layer, Rect, Stage, Text, Transformer } from "react-konva";
import useImage from "use-image";
import { IMAGE } from "./dummyImage";

export default function FrameCanvas(props) {

    const [height, width] = [829.5, 553];
    const [targetHeight, targetWidth] = [639, 426];
    const [placeholderImages, setPlaceholderImages] = useState([])
    const [baseImageSize, setBaseImageSize] = useState([1080, 1920])
    const [showMenu, setShowMenu] = useState(false)
    const [menuPos, setMenuPos] = useState([50, 50])
    const [isTakingScreenshot, setIsTakingScreenshot] = useState(false)
    const [redDot, setRedDot] = useState([50, 50])

    const nImage = props.nImage;
    const [frameImage] = useImage(props.frameURL, 'Anonymous')

    const stageRef = useRef(null)
    const tRef = useRef(null)

    const SCALE = 0.1

    const handleDragStart = (e) => {
        const key = e.target.attrs.name;
        const items = placeholderImages.slice();
        const item = items.find((i) => i.key === key);
        const index = items.indexOf(item);
        // remove from the list:
        items.splice(index, 1);
        // add to the top
        items.push(item);
        setPlaceholderImages(items);
    };

    const onDragEnd = (e) => {
        const key = e.target.attrs.name;
        const items = placeholderImages.slice();
        const item = placeholderImages.find((i) => i.key === key);
        const index = placeholderImages.indexOf(item);
        // update item position
        items[index] = {
            ...item,
        };
        setPlaceholderImages(items);
    };

    function getCrop(image, size) {
        const tmpWidth = size.width;
        const tmpHeight = size.height;
        const aspectRatio = tmpWidth / tmpHeight;

        let newWidth;
        let newHeight;
        let oldWidth = image.width
        let oldHeight = image.height

        const imageRatio = oldWidth / oldHeight;

        if (aspectRatio >= imageRatio) {
            newWidth = oldWidth;
            newHeight = oldWidth / aspectRatio;
        } else {
            newWidth = oldHeight * aspectRatio;
            newHeight = oldHeight;
        }

        let x = 0;
        let y = 0;
        x = (oldWidth - newWidth) / 2;
        y = (oldHeight - newHeight) / 2;

        return {
            cropX: x,
            cropY: y,
            cropWidth: newWidth,
            cropHeight: newHeight,
        };
    }

    function applyCrop(e) {
        const img = e.target;
        const crop = getCrop(
            img.attrs.image,
            {
                width: img.attrs.width,
                height: img.attrs.height,
            }
        );
        img.setAttrs(crop);
    }

    function spawnPlaceholderImage() {
        var out = []
        const [nRow, nCol] = [Math.ceil(nImage / 2), 2];
        for (let i = 0; i < nImage; i++) {
            const testImage = new window.Image()
            testImage.src = `placeholders/${((i) % nRow) + 1}.png`
            setBaseImageSize([testImage.height, testImage.width])
            out.push({
                key: `${i + 1}`,
                x: 50 + Math.floor(i / nRow) * (width / (nCol + 2) * 2),
                y: 50 + Math.floor((i % nRow)) * (height / (nRow + 2)),
                image: testImage,
                height: testImage.height * SCALE,
                width: testImage.width * SCALE,
                angle: 0,
                isSquare: false,
                cropHeight: testImage.height * SCALE,
                cropWidth: testImage.width * SCALE,
            })
        }
        setPlaceholderImages(out)
    }

    function handleDelete() {
        const selected = tRef.current._nodes[0]
        tRef.current._nodes = []
        const key = selected.attrs.name
        selected.destroy()
        const items = placeholderImages.slice()
        const item = placeholderImages.find(i => i.key == key)
        const idx = placeholderImages.indexOf(item)
        items.splice(idx, 1);
        props.onImageRemove(item.idImage)
        setPlaceholderImages(items)
    }

    function spawnOneImage(i) {
        const n = placeholderImages.length
        var content = placeholderImages.slice()
        const [nRow, nCol] = [Math.floor(nImage / 2), 2];
        const testImage = new window.Image()
        testImage.src = `placeholders/${parseInt(i) + 1}.png`
        content.push({
            idImage: i,
            key: `${new Date().getTime()}`,
            x: 50 + Math.floor(n / nRow) * (width / (nCol + 2) * 2),
            y: 50 + Math.floor((n % nRow)) * (height / (nRow + 2)),
            image: testImage,
            height: baseImageSize[0] * SCALE,
            width: baseImageSize[1] * SCALE,
            angle: 0,
            isSquare: false,
            cropHeight: testImage.height * SCALE,
            cropWidth: testImage.width * SCALE,
        })
        setPlaceholderImages(content)
    }

    function renderPlaceholders() {
        var clone = { ...props.images }
        placeholderImages.forEach((img) => {
            var id = parseInt(img.idImage)
            clone[id] -= 1
        })
        for (const [key, value] of Object.entries(clone)) {
            if (value == 1) {
                spawnOneImage(key)
            }
        }
    }

    function selectImage(e) {
        tRef.current.nodes([e.target])
    }

    function unselectImage(e) {
        if (e.target == stageRef.current) {
            tRef.current.nodes([])
        }
    }

    function updateSize(e) {
        tRef.current.nodes([e.target])
        const img = e.target
        const tmp = {
            scaleX: 1,
            scaleY: 1,
            width: img.attrs.width * img.attrs.scaleX,
            height: img.attrs.height * img.attrs.scaleY,
        }
        applyCrop(e)
        img.setAttrs(tmp)
    }

    useEffect(() => {
        setPlaceholderImages([])
        // spawnPlaceholderImage();
    }, [props.nImage, props.isDuplicate])

    useEffect(() => {
        if (props.testLayoutClicked) {
            generateJson()
        }
    }, [props.testLayoutClicked])

    useEffect(() => {
        if (props.images && (placeholderImages.length < nImage)) {
            renderPlaceholders()
        }
    }, [props.images])

    useEffect(() => {
        if (props.isSaveClicked) {
            tRef.current.nodes([])
            setIsTakingScreenshot(true)
            setTimeout(() => {
                const img = stageRef.current.toDataURL()
                props.uploadImage(img)
                generateJson()
                setIsTakingScreenshot(false)
            }, 1000);
        }
    }, [props.isSaveClicked])

    function getCoorBeforeRotate(img) {
        const [oldX, oldY] = [img.attrs.x, img.attrs.y]
        const [width, height] = [img.attrs.width, img.attrs.height]
        const diagonalAngle = Math.atan(height / width)
        const angle = (img.attrs.rotation * Math.PI / 180) + diagonalAngle
        const radiusLength = Math.sqrt((width * width) + (height * height)) / 2
        const topLeft = {
            x: oldX,
            y: oldY,
        }
        const center = {
            cx: topLeft.x + (Math.cos(angle) * radiusLength),
            cy: topLeft.y + (Math.sin(angle) * radiusLength),
        }

        // setRedDot([center.cx - width/2, center.cy - height/2])

        return [center.cx - width / 2, center.cy - height / 2]
    }

    function generateJson() {
        var jsonOut = []
        const [targetScaleX, targetScaleY] = [targetWidth / width, targetHeight / height]
        const canvasRef = stageRef.current.children[0].children.slice(0, -1)
        const isDuplicate = !(Object.keys(props.images).length == nImage)
        const n = isDuplicate ? nImage / 2 : nImage
        var out = new Array(n)
        for (let index = 0; index < n; index++) {
            out[index] = [];
        }

        placeholderImages.forEach((img) => {
            const item = canvasRef.find((i) => i.attrs.name == img.key)
            const [x, y] = getCoorBeforeRotate(item)
            const temp = {
                idImage: img.idImage,
                type: 'image',
                isSquare: img.isSquare,
                left: (x * targetScaleX).toFixed(4),
                top: (y * targetScaleY).toFixed(4),
                scaleY: (item.attrs.height * targetScaleX / baseImageSize[0]).toFixed(4),
                scaleX: (item.attrs.width * targetScaleY / baseImageSize[1]).toFixed(4),
                height: baseImageSize[0],
                width: baseImageSize[1],
                angle: (item.attrs.rotation).toFixed(4),
            }
            out[img.idImage].push(temp)
        })

        // fill missing element
        for (const [key, value] of Object.entries(props.images)) {
            for (let index = 0; index < (isDuplicate ? 2 : 1) - value; index++) {
                out[key].push(IMAGE(key))
            }
        }

        if (isDuplicate) {
            // rearrange json into intended order [1, 2, 3, 3, 2, 1] (mirror)
            for (let index = n - 1; index >= 0; index--) {
                jsonOut.unshift(out[index][0])
                jsonOut.push(out[index][1])
            }
        } else {
            for (let index = 0; index < n; index++) {
                jsonOut.push(out[index][0])
            }
        }

        props.setLayout(JSON.stringify(Object.values(jsonOut), null, 4))
        props.setTestLayoutClicked(false)
    }

    return (
        <Stage
            width={width}
            height={height}
            ref={stageRef}
            onClick={(e) => {
                unselectImage(e)
                setShowMenu(false)
            }}
        >
            {(props.isFrameInBack && !isTakingScreenshot) &&
                <Layer>
                    <Image
                        visible={props.showFrame}
                        key={'frame'}
                        name={'frame'}
                        x={0}
                        y={0}
                        width={width}
                        height={height}
                        image={frameImage}
                        listening={false}
                    />
                </Layer>
            }
            <Layer>
                {placeholderImages.map((image) => (
                    <Image
                        key={image.key}
                        name={image.key}
                        x={image.x}
                        y={image.y}
                        height={image.height}
                        width={image.width}
                        rotation={image.angle}
                        image={image.image}
                        draggable
                        onContextMenu={(e) => {
                            e.evt.preventDefault()
                            setShowMenu(true)
                            setMenuPos([
                                e.evt.offsetX,
                                e.evt.offsetY
                            ])
                        }}
                        onDragStart={handleDragStart}
                        onDragEnd={onDragEnd}
                        onClick={(e) => {
                            e.evt.preventDefault()
                            setShowMenu(false)
                            selectImage(e)
                        }}
                        onTransform={(e) => {
                            updateSize(e)
                        }}
                    />
                ))}
                {/* <Circle x={redDot[0]} y={redDot[1]} fill="red" radius={4}/> */}
                <Transformer
                    ref={tRef}
                    flipEnabled={false}
                />
                <Rect
                    visible={showMenu}
                    fill="red"
                    x={menuPos[0]}
                    y={menuPos[1]}
                    width={100}
                    height={30}
                    onClick={(e) => {
                        e.evt.preventDefault()
                        handleDelete()
                    }}
                />
                <Text
                    visible={showMenu}
                    fill="white"
                    x={menuPos[0] + 30}
                    y={menuPos[1] + 10}
                    text="Delete"
                    onClick={(e) => {
                        e.evt.preventDefault()
                        handleDelete()
                    }}
                />
            </Layer>
            {(!props.isFrameInBack || isTakingScreenshot) &&
                <Layer>
                    <Image
                        visible={props.showFrame || isTakingScreenshot}
                        key={'frame'}
                        name={'frame'}
                        x={0}
                        y={0}
                        width={width}
                        height={height}
                        image={frameImage}
                        listening={false}
                    />
                </Layer>
            }
        </Stage>
    )
}